import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateLooseCustomerRecipeInput } from './UpdateLooseCustomerRecipeInput';
import { UpdateLooseCustomerRecipeOutput } from './UpdateLooseCustomerRecipeOutput';

export class UpdateLooseCustomerRecipeService extends HttpServiceBase {

  handle = (input: UpdateLooseCustomerRecipeInput): Promise<Result<UpdateLooseCustomerRecipeOutput> | null> => {
    const promise = this.http.put<Result<UpdateLooseCustomerRecipeOutput>, UpdateLooseCustomerRecipeInput>(
      `${this.baseUrlSislogApi}/v2/customer-recipe/${input.customerRecipeId}/loose`, input);
    return promise;
  }
}